import {Injectable} from '@angular/core';
import {HttpClient, HttpHeaders} from '@angular/common/http';
import {Observable, of} from 'rxjs';
import {retry} from 'rxjs/operators';
import {FormArray} from '@angular/forms';

import config from 'src/assets/tmp/result-config-nanogrid.json';
import {AbstractRestService} from './abstract-rest.service';
import {ConfigNanoGrid} from '../../modules/nanogrid/models/config-nanogrid.model';
import {User} from '../models/app-user';
import {BilateralContracts} from '../../modules/price-prediction/models/bilateral-contracts';
import {ResultEsito} from '../../modules/price-prediction/models/result';

@Injectable({
    providedIn: 'root',
})
export class DataService extends AbstractRestService {

    constructor(
        private http: HttpClient
    ) {
        super();
    }

    salvaConfigurazione(formArray: FormArray) {
        return this.http.put<boolean>(`${this.baseURL}/configuration`, formArray);
    }

    hasConfigurationYet(selectedId): Observable<boolean> {
        return this.http.get<boolean>(`${this.baseURL}/configuration/user/${selectedId}`).pipe(retry(3));
    }

    getPrevisioneConsumiLast24h(params): Observable<number[]> {
        return this.http.post<number[]>(`${this.baseURL}/previsioneConsumi/getLast24h`, params).pipe(retry(3));
    }

    getPrevisioneProduzioneLast24h(params): Observable<number[]> {
        return this.http.post<number[]>(`${this.baseURL}/previsioneProduzione/getLast24h`, params).pipe(retry(3));
    }

    getPrevisioneScambioNotarizzato(params): Observable<number[]> {
        const p = {'dataPrevisione': params.from, 'idUser': params.id};
        return this.http.post<number[]>(`${this.powerCloudURL}/getPrevisioneScambioLast24h`, p).pipe(retry(3));
    }

    getUsers() {
        return this.http.get<User[]>(`${this.baseURL}/utente/allNameAndSurname`);
    }

    getScoreSM(params): Observable<number> {
        return this.http.post<number>(`${this.powerCloudURL}/getScoreLast24h`, params).pipe(retry(3));
    }

    getAutoconsumoGiornoPrecedente() {
        return this.http.get<number>(`${this.powerCloudURL}/getPrevisioneAutoConsumo`).pipe(retry(3));
    }

    getScoreAggregation(params): Observable<number> {
        return this.http.post<number>(`${this.powerCloudURL}/getScoreLast24h`, params).pipe(retry(3));
    }

    getConsumoRealeLast24h(params): Observable<number[]> {
        return this.http.post<number[]>(`${this.powerCloudURL}/getConsumoRealeLast24h`, params).pipe(retry(3));
    }

    getProduzioneRealeLast24h(params): Observable<number[]> {
        const headers = new HttpHeaders();
        headers.append('Content-Type', 'application/json');
        return this.http.post<number[]>(`${this.powerCloudURL}/getProduzioneRealeLast24h`, params).pipe(retry(3));
    }

    getScambioRealeLast24h(params): Observable<number[]> {
        const headers = new HttpHeaders();
        headers.append('Content-Type', 'application/json');
        return this.http.post<number[]>(`${this.powerCloudURL}/getScambioRealeLast24h`, params).pipe(retry(3));
    }

    getIdSmartMeters(): Observable<number[]> {
        const headers = new HttpHeaders();
        headers.append('Content-Type', 'application/json');
        return this.http.get<number[]>(`${this.smURL}/smartmeters/ids`);
    }

    getAvg(params1): Observable<ResultEsito> {
        const headers = new HttpHeaders();
        headers.append('Content-Type', 'application/json');
        return this.http.post<ResultEsito>(`${this.powerCloudURL}/avgByDataAndFascia`, params1);
    }

    getRisultatiMatlab(params): Observable<ResultEsito> {
        const headers = new HttpHeaders();
        headers.append('Content-Type', 'application/json');
        return this.http.post<ResultEsito>(`${this.powerCloudURL}/readMatlabResult`, params);
    }

    getContrattiBilaterali(): Observable<BilateralContracts[]> {
        const headers = new HttpHeaders();
        headers.append('Content-Type', 'application/json');
        return this.http.get<BilateralContracts[]>(`${this.powerCloudURL}/contrattiBilaterali`);
    }

    saveConfigNanoGrid(result: ConfigNanoGrid): Observable<any> {
        const headers = new HttpHeaders();
        headers.append('Content-Type', 'application/json');
        return this.http.post<any>(`${this.configurationURL}/configSRI/save`, result);
    }

    saveNewuser(result: ConfigNanoGrid): Observable<any> {
        const headers = new HttpHeaders();
        headers.append('Content-Type', 'application/json');
        return this.http.post<any>(`${this.configurationURL}//configUser/save`, result);
    }

    getConfigNanoGrid(userId: any): Observable<ConfigNanoGrid> {

        return this.http.post<ConfigNanoGrid>(`${this.configurationURL}/configSRI/get`, userId);
    }

    getSri(userId: number): Observable<number> {

        return this.http.post<number>(`${this.configurationURL}/configSRI/getSRI`, userId);
    }
}
